import Script from 'next/script';
import assetUrls from '@amzn/katal-components/asseturls';
import { Helmet } from 'react-helmet-async';
import GlobalBanners from 'src/components/GlobalBanners';
import PermissionsModal from 'src/components/PermissionsModal';
import SearchBar from 'src/components/SearchBar';
import AppNavbar from 'src/components/AppNavbar';
import AppNavigation from 'src/components/navigation';
import RouteHistory from 'src/components/RouteHistory';
import { useAppSelector } from 'src/redux/hooks';
import { AppState } from 'src/redux/store';
import { USER_TOKEN } from 'src/utils/request';
import { MediaContextProvider } from 'src/utils/media';
import { useCheckWeblab, useTranslation } from 'src/utils';
import WeblabId from 'src/weblab/weblabId';
import { useEffect } from 'react';

export default function AppLayout({ children }: React.PropsWithChildren) {
  const userToken = useAppSelector(({ userInfo }: AppState) => userInfo.userToken);
  const removeFixedWidth = useCheckWeblab(WeblabId.SELLER_FORUMS_VIEWPORT_WIDTH_REMOVAL);
  const isAdaptiveNavbar = useCheckWeblab(WeblabId.SELLER_FORUMS_NAVBAR_ADAPTIVE);
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.reloadResources(i18n.resolvedLanguage, ['common']);
  }, [i18n]);
  return (
    <div id="seller-forums" className="katal min-h-[85vh]">
      <Script src={assetUrls.urls.prod} />
      <Helmet htmlAttributes={{ dir: typeof window !== 'undefined' && document.documentElement.dir ? document.documentElement.dir : 'ltr' }}>
        <meta name={USER_TOKEN} content={userToken} />
        {!removeFixedWidth && <meta name="viewport" content="width=1280" /> }
        {
        typeof window !== 'undefined' && <link rel="canonical" href={window.location.href.split('?')[0]} />
      }
      </Helmet>
      <MediaContextProvider>
        <RouteHistory />
        <PermissionsModal />
        {
          isAdaptiveNavbar ? <AppNavigation /> : (
            <>
              <AppNavbar />
              <SearchBar />
            </>
          )
        }
        <GlobalBanners />
        {children}
      </MediaContextProvider>
    </div>
  );
}
